import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-custom-table-cell',
  templateUrl: './custom-table-cell.component.html',
  styleUrls: ['./custom-table-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTableCellComponent implements OnInit {
  @Input() widthPx?: number;
  @HostBinding('style') style: string | null = null;

  constructor() {}

  ngOnInit() {
    if (this.widthPx) {
      this.style = `min-width: ${this.widthPx}px`;
    }
  }
}
